import { triggerEvent, isScrolledIntoView } from '../helpers';

class Menu {
  constructor() {
    this.elements = {
      header: document.querySelector('header'),
      hamburger: document.querySelector('.the-hamburger'),
      close: document.querySelector('.onclose'),
      nav: document.querySelector('#megamenu'),

    }

    this.settings = {
      offset: 98,
      scrollOffset: 300,
    }
    
    this.toggleMegaMenu();
    this.initFoundationHeader();
    this.initScrollLinks();
  }

  toggleMegaMenu() {
    const {hamburger, close, nav, header} = this.elements;

    hamburger.addEventListener('click', e => {
      e.preventDefault();

      header.classList.add('hidden');
      nav.classList.remove('hidden');
      nav.classList.add('slide-bottom');
      nav.classList.remove('slide-top');
    })

    close.addEventListener('click', (e) => {
      e.preventDefault();

      header.classList.remove('hidden');
      nav.classList.add('slide-top');
      nav.classList.remove('slide-bottom');

      setTimeout(function () {
        nav.classList.add('hidden');
      }, 500);
    });
  }

  initFoundationHeader() {
    const { header } = this.elements;
    const { scrollOffset } = this.settings;

    if (!header.classList.contains('js-foundation-header')) return;

    const hasSnap = document.body.classList.contains('has-snap-layout');

    if (hasSnap) {
      return;
    }

    var prevScrollpos = window.pageYOffset;

    window.addEventListener('scroll', () => {
      var currentScrollPos = window.pageYOffset;

      if (currentScrollPos > scrollOffset) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled')
      }

      prevScrollpos = currentScrollPos;
    });
  }

  initScrollLinks() {
    const links = document.querySelectorAll(".is-scroll");
    const collection = document.querySelectorAll('a');

    if( collection.length !== 0 ) {
      const $root = $('html, body');
      collection.forEach((el) => {
          if( el.classList.contains('js-anchor-initialized') ) { return; }
          const href = el.getAttribute('href');
          if(!href) return;
          const target = document.getElementById(href.substring(href.indexOf("#") + 1));
          el.classList.add('js-anchor-initialized');

          if( target ) {
              el.addEventListener("click", (event) => {
                  event.preventDefault();
                  $root.animate({
                      scrollTop: $(target).offset().top - this.settings.offset
                  }, 500, 'swing');

                  return false;
              });
          } 
      });
    }
  
    if( links.length !== 0 ){
        links.forEach(el => {
            const href = el.childNodes[0].getAttribute('href');
            const target = document.getElementById(href.substring(href.indexOf("#") + 1));
            if(target) {
                window.addEventListener('scroll', () => {
                    const vh = document.documentElement.clientHeight - this.elements.header.offsetHeight;
                    const rect = target.getBoundingClientRect();
                    const top = Math.abs(rect.top - vh/2 + target.offsetHeight/2);
                    const offset = target.offsetHeight/2;
                    if( top < offset || isScrolledIntoView(target, -200) ) {
                        el.classList.add("in-view");
                    }
                    else {
                        el.classList.remove("in-view");
                    }
                }, {passive: true});
                triggerEvent(window, 'scroll');
            }
        });
    }
  }
}

export { Menu };
